"use strict";
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = {
  props: ['network', 'user', 'toggle'],
  computed: {
    isUserSelf: function isUserSelf() {
      if (this.toggle === false) {
        return false;
      }

      var user = this.$state.getUser(this.network.id, this.network.nick);
      return this.user === user;
    },
    shouldShowStatus: function shouldShowStatus() {
      if (!this.$state.setting('showAwayStatusIndicators')) {
        return false;
      }

      if (this.network.state !== 'connected') {
        return false;
      }

      var awayNotifyEnabled = this.network.ircClient.network.cap.isEnabled('away-notify');
      return this.$state.setting('buffers.who_loop') || awayNotifyEnabled;
    }
  },
  methods: {
    toggleSelfAway: function toggleSelfAway() {
      if (this.isUserSelf) {
        var val = this.user.isAway();
        this.network.ircClient.raw('AWAY', val ? '' : 'Currently away');
      }
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AwayStatusIndicator"]
window._kiwi_exports.components.AwayStatusIndicator = exports.default ? exports.default : exports;
